import React, { useState } from "react";
import { companyFormToast, companyFormToastError } from "./companyFormSwal";

export default function CompanyFormsAddCategoryField({ onCreate, onCreated }) {
  const [open, setOpen] = useState(false);
  const [label, setLabel] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!onCreate) return;
    setBusy(true);
    try {
      const created = await onCreate(label);
      setLabel("");
      setOpen(false);
      if (created?.slug && onCreated) {
        onCreated(created.slug);
      }
      companyFormToast({
        title: "Category added",
        text: `"${created?.label || label}" is available in the list.`,
      });
    } catch (error) {
      companyFormToastError(
        "Could not add category",
        error.response?.data?.message || error.message || "Try again.",
      );
    } finally {
      setBusy(false);
    }
  };

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="company-forms-btn mt-1.5 text-[11px] font-semibold text-[#007BFF] hover:underline"
        style={{ border: "none", background: "transparent", padding: 0 }}
      >
        + Add new category
      </button>
    );
  }

  return (
    <div className="mt-2 rounded-lg border border-slate-200 bg-slate-50/80 p-3">
      <p className="mb-2 text-[11px] font-semibold text-slate-700">New category name</p>
      <div className="flex flex-wrap gap-2">
        <input
          type="text"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          placeholder="e.g. Privacy Policy"
          maxLength={120}
          className="min-w-0 flex-1 rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-[#007BFF]/50 focus:ring-2 focus:ring-[#007BFF]/15"
        />
        <button
          type="button"
          disabled={busy || !label.trim()}
          onClick={submit}
          className="company-forms-btn rounded-lg bg-[#007BFF] px-3 py-2 text-xs font-semibold text-white hover:bg-[#0069d9] disabled:opacity-60"
        >
          {busy ? "Saving…" : "Save"}
        </button>
        <button
          type="button"
          disabled={busy}
          onClick={() => {
            setOpen(false);
            setLabel("");
          }}
          className="company-forms-btn rounded-lg px-3 py-2 text-xs font-semibold text-slate-600 hover:bg-white"
          style={{ border: "none" }}
        >
          Cancel
        </button>
      </div>
      <p className="mt-2 text-[10px] leading-snug text-slate-500">
        Available to all staff in View documents after you upload a document in this category.
      </p>
    </div>
  );
}
